export default __webpack_public_path__ + "static/pskBannerImg-d49cf9b26f3e9ede18338c1f11c2a150.png";